// intents.js — why someone is on Jale, and how that tailors the app.
//
// Stored on users/{uid}: intents (string[], in the order picked — the first is
// the "primary") and intentSetAt (set even when skipped, so we only ask once).
// Tailoring reorders and highlights; it never hides anything.
//
// Ad links can pre-select an intent with ?for=… (see AD_PARAM), e.g.
//   jaletrailers.com/?for=owners
// which also tailors Home for signed-out visitors before they sign up.
// Labels here must match INTENT_LABELS in functions/admin/rollup.js.

export const INTENTS = [
  {
    key: "rent",
    label: "Rent a trailer",
    blurb: "Find a trailer for a job, a move or a weekend project.",
    headline: "Find a trailer to rent",
    sub: "Search rentals near you by type, price and dates.",
    cta: { label: "Search rentals", action: "search" },
    next: "/",
  },
  {
    key: "list",
    label: "Rent out or sell my trailer",
    blurb: "Make money from a trailer you own.",
    headline: "Put your trailer to work",
    sub: "List it once. Get booking requests, track your earnings in Insights.",
    cta: { label: "List your trailer", to: "/create-post" },
    secondary: { label: "Your Insights", to: "/insights" },
    next: "/create-post",
  },
  {
    key: "buy",
    label: "Buy a trailer",
    blurb: "Browse trailers for sale from local owners.",
    headline: "Find a trailer to buy",
    sub: "Browse trailers for sale from owners near you.",
    cta: { label: "Browse for sale", action: "search" },
    next: "/",
  },
  {
    key: "post",
    label: "Get a job done",
    blurb: "Post a job and get quotes from people nearby.",
    headline: "Get the job done",
    sub: "Post what you need and get quotes from people nearby.",
    cta: { label: "Post a job", to: "/create-job" },
    secondary: { label: "Browse jobs", to: "/jobs" },
    next: "/create-job",
  },
  {
    key: "work",
    label: "Find work",
    blurb: "Pick up paid jobs near you.",
    headline: "Find work near you",
    sub: "Open jobs from people nearby. Send a quote, get booked, get paid.",
    cta: { label: "Browse open jobs", to: "/jobs" },
    next: "/jobs",
  },
];

export const INTENT_BY_KEY = Object.fromEntries(INTENTS.map((i) => [i.key, i]));

// ?for= values an ad link can use → intent key. Several spellings each, so a
// typo in an ad doesn't silently lose the tailoring.
export const AD_PARAM = {
  renters: "rent", rent: "rent", rentals: "rent",
  owners: "list", owner: "list", sellers: "list", sell: "list", list: "list",
  buyers: "buy", buy: "buy",
  jobs: "post", post: "post", hire: "post",
  workers: "work", work: "work", haulers: "work",
};

// Home's listing-type filter to preselect for an intent.
export const LISTING_TYPE_FOR = { rent: "rent", buy: "sale" };
